import React, { useState, useCallback, useMemo, useEffect } from 'react';
import { z } from 'zod';
import Modal from '../../components/Modal';
import CustomInput from '../../components/CustomInput';
import ActionButtons from '../../components/ActionButtons';
import CustomSelect from '../../components/CustomSelect';
import CustomTextArea from '../../components/CustomTextArea';
import { INITIAL_FORM_STATE, INITIAL_ERROR_STATE, getFormConfig, CONSTITUTION_SCHEMA } from './config';
import DatePicker from '../../components/DatePicker';
import clsx from 'clsx';
import { inputStyles, errorStyles } from '../../styles/styles';

const ConstitutionModal = ({
    handleSubmit,
    isOpen,
    onClose,
    isEdit = false,
    handleChange,
    handleFileChange,
    form,
    files,
    isLoading,
    status, errors, 
}) => {

 

    // Memoize labels
    const labels = useMemo(
        () => ({
            normalLabel: isEdit ? 'Update Constitution' : 'Create Constitution',
            loadingLabel: isEdit ? 'Updating...' : 'Creating...'
        }),
        [isEdit]
    );

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={isEdit ? 'UPDATE CONSTITUTION' : 'CREATE NEW CONSTITUTION'}>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label htmlFor="title" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Title
                    </label>
                    <input
                        id="title"
                        autoComplete="off"
                        type="text"
                        placeholder="Enter Constitution title"
                        name="title"
                        value={form?.title || ''}
                        onChange={(e) => handleChange('title', e.target.value)}
                        className={clsx(inputStyles, errors?.title && 'border-red-500 dark:border-red-400')}
                    />
                    {errors?.title && <p className={errorStyles}>{errors?.title}</p>}
                </div>
                <div>
                    <label htmlFor="date" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Date
                    </label>
                    <input
                        id="date"
                        autoComplete="off"
                        type="date"
                        placeholder="Select date"
                        name="date"
                        value={form?.date || ''}
                        onChange={(e) => handleChange('date', e.target.value)}
                        className={clsx(inputStyles, errors?.date && 'border-red-500 dark:border-red-400')}
                    />
                    {errors?.date && <p className={errorStyles}>{errors?.date}</p>}
                </div>
                <div>
                    <label htmlFor="date" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Description
                    </label>
                    <textarea
                        id="description"
                        autoComplete="off"
                        placeholder="Enter Description"
                        name="description"
                        value={form?.description || ''}
                        onChange={(e) => handleChange('description', e.target.value)}
                        className={clsx(inputStyles, errors?.description && 'border-red-500 dark:border-red-400')}
                    />
                    {errors?.description && <p className={errorStyles}>{errors?.description}</p>}
                </div>
                <div>
                    <label htmlFor="date" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Manual
                    </label>
                    <input
                        id="manual"
                        autoComplete="off"
                        type="file"
                        placeholder="Upload Manual"
                        name="manual"
                        value={form?.manual || ''}
                        accept=".pdf,.doc,.docx"
                        onChange={(e) => {
                            handleFileChange('manual', e.target.files[0]);
                            handleChange('manual', e.target.value);
                        }}
                        className={clsx(inputStyles, errors?.manual && 'border-red-500 dark:border-red-400')}
                    />
                    {errors?.manual && <p className={errorStyles}>{errors?.manual}</p>}
                </div>
                <div>
                    <label htmlFor="date" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Thumbnail
                    </label>
                    <input
                        id="thumbnail"
                        autoComplete="off"
                        type="file"
                        placeholder="Upload Thumbnail"
                        name="thumbnail"
                        value={form?.thumbnail || ''}
                        accept=".jpg,.jpeg,.png"
                        onChange={(e) => {
                            handleFileChange('thumbnail', e.target.files[0]);
                            handleChange('thumbnail', e.target.value);
                        }}
                        className={clsx(inputStyles, errors?.thumbnail && 'border-red-500 dark:border-red-400')}
                    />
                    {errors?.thumbnail && <p className={errorStyles}>{errors?.thumbnail}</p>}
                </div>

                <ActionButtons isLoading={isLoading} onClose={onClose} onSubmit={handleSubmit} isEdit={isEdit} label={labels} />
            </form>
        </Modal>
    );
};

export default React.memo(ConstitutionModal);
